import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../core/authentication.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Login } from '../../shared/models/login';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  login: Login;
  loginForm: FormGroup;
  error: string = '';

  constructor(private router: Router,
              private authSrv: AuthenticationService,
              private fb: FormBuilder) { }

  ngOnInit() {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  onLogin() {
    this.login = this.loginForm.value;
    this.authSrv.login(this.login.username, this.login.password)
    .subscribe((login) => {
          if ( login ) {
            this.router.navigate(['dashboard'])
          }else {
            this.error = 'Identifiants Incorrectes';
          }
    },  (res: Response) => {
      this.error = res.json()['message'];
    } );
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/authentication/login/login.component.ts